import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart } from '../../Portfolio/CardIndicator/Cards';
import { HeaderData } from './HeaderData/HeaderData';
import styles from './ProjectsByCountry.module.scss';
import { Table } from './Table/Table';
import { handleDataInDetail } from './Util';
import { useProjectsByCountryData } from './useProjectsByCountryData';
import SpinningLoader from '../../ProjectDetail/ProjectTabs/Loader/SpinningLoader';
import { ProjectsListSkeleton } from '../../LoadersSkeletons/ProjectsListSkeleton/ProjectsListSkeleton';
import ErrorMessageView from '../../Util/ErrorMessage/ErrorMessageView';

const handleDynamicChartDimensions = data => {
  const quantity = data && data.subLabels && data.subLabels.length;
  return {
    mobile: { width: 320, height: quantity ? quantity * 20 : 320 },
    desktop: { width: 320, height: quantity && quantity > 10 ? quantity * 15 : 550, cursor: 'pointer' },
  };
};

export const ProjectsByCountry = () => {
  const { t } = useTranslation();
  const {
    projects,
    currentIndicator,
    selectedCountry,
    isChartLoading,
    isProjectsLoading,
    hasChartError,
    hasProjectsError,
    reloadChart,
    reloadProjects,
    selectCountry,
  } = useProjectsByCountryData();
  const { type, data, detailTitle, detailChartFoot, totalProjects } = currentIndicator;
  const qtyCountries = data?.labels?.length || 0;
  const {
    chartDetailContainer,
    capitalizeWord,
    subTitle,
    chartSection,
    projectsByCountryContainer,
    chartContainer,
    tableContainer,
    title,
    footerTitle,
    footerSubTitle,
    tableSection,
    tableDetail,
    titleUpper,
    description,
    left,
    right,
  } = styles;
  return (
    <>
      <div className={projectsByCountryContainer}>
        {!hasChartError ? (
          <>
            <div className={chartSection}>
              <div className={chartDetailContainer}>
                <div className={title}>{t(detailTitle || 'countries')}</div>
                <div className={subTitle}>
                  <span className={capitalizeWord}> {t('total')}</span>: {` ${qtyCountries ?? 0} `}
                  {t('countries')}
                </div>
                <div className={chartContainer}>
                  {!isChartLoading ? (
                    <BarChart
                      type={type}
                      data={handleDataInDetail(currentIndicator)}
                      showSubLabels={false}
                      listPage={true}
                      datasetClick={selectCountry}
                      chartDimensions={handleDynamicChartDimensions(data)}
                    />
                  ) : (
                    <SpinningLoader customStyle={{ marginBottom: 85 }} />
                  )}
                </div>
                <div className={footerTitle}>{t(detailChartFoot || 'number_of_projects')}</div>
                <div className={footerSubTitle}>
                  <span className={capitalizeWord}> {t('total')}</span>: {totalProjects ?? 0} {t('projects')}
                </div>
              </div>
            </div>
            <div className={tableSection}>
              <div className={tableDetail}>
                <div className={titleUpper}>{t('country')}</div>
                <div className={description}>
                  <div className={left}>{selectedCountry.name}</div>
                  <div className={right}>
                    <HeaderData country={selectedCountry} />
                  </div>
                </div>
                <div className={tableContainer}>
                  {isProjectsLoading ? (
                    <ProjectsListSkeleton />
                  ) : hasProjectsError ? (
                    <ErrorMessageView
                      title={t('title_error_message_view')}
                      description={t('desc_error_message_tab')}
                      reload={reloadProjects}
                      isIndicator={true}
                    />
                  ) : (
                    <Table projects={projects} />
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="error-message-style">
            <ErrorMessageView
              title={t('title_error_message_view')}
              description={t('desc_error_message_tab')}
              reload={reloadChart}
              isIndicator={true}
            />
          </div>
        )}
      </div>
    </>
  );
};
